import { TextField } from "@mui/material"

export default function TextFieldNumber({
    value,
    onChange,
    decimal = true,
    error,
    date,
    inputProps,
    twoDecimalDigits = false,
    max,
    min,
    ...props
}) {

    const changeHandler = ({ target: { name, value } }) => {
        let regex = /^(0|[1-9][0-9]*|\.[0-9]+|[0-9]+\.[0-9]*)$/

        if (date) {
            regex = /^[0-9][0-9]*$/
        } else if (decimal === false) {
            regex = /^(0|[1-9][0-9]*)$/
        } else if (twoDecimalDigits) {
            regex = /^(0|[1-9][0-9]*|\.[0-9]{0,2}|[0-9]+\.[0-9]{0,2})?$/
        }
        if (value === '' || value.match(regex)) {
            if (!!max && Number(value) > max) {
                return
            }
            onChange({ target: { name: name, value } })
        }
    }

    return (
        <TextField
            inputProps={{ inputMode: 'numeric', ...inputProps }}
            value={value}
            onChange={changeHandler}
            error={!!error}
            helperText={error ?? ''}
            InputLabelProps={{
                sx: {
                    color: "text.placeholder",
                },
            }}
            {...props}
        />
    )
}